import { FC } from 'react';
import * as React from 'react';

const RouteWrapper: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <div
    className="w-full flex flex-col py-24 font-body3"
    css={`
      & section {
        display: flex;
        flex-direction: column;
        &:not(:last-child) {
          margin-bottom: 16px;
        }
        & p,
        ul,
        ol {
          &:not(:last-child) {
            margin-bottom: 8px;
          }
        }
        & li {
          list-style-position: outside;
          &:not(:last-child) {
            margin-bottom: 4px;
          }
        }
        & ul,
        ol {
          padding-left: 20px;
        }
        & ul > li {
          list-style-type: disc;
        }
        & ol > li {
          list-style-type: lower-latin;
        }
        & strong {
          font-weight: 700;
        }
      }
    `}
  >
    {children}
  </div>
);

export default RouteWrapper;
